import { useState, useCallback, memo } from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar } from './AppSidebar';
import { Header } from './Header';
import { Footer } from './Footer';
import { cn } from '@/lib/utils';
import { SidebarProvider } from '../ui/sidebar';

export const AppLayout = memo(function AppLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMenuToggle = useCallback(() => {
    setMobileMenuOpen(prev => !prev);
  }, []);

  const handleOverlayClick = useCallback(() => {
    setMobileMenuOpen(false);
  }, []);

  return (
    <div className="flex min-h-screen w-full">
      <SidebarProvider>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:block" aria-label="Main navigation">
        <AppSidebar />
      </aside>

      {/* Mobile Sidebar Overlay */}
      {mobileMenuOpen && (
        <div 
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={handleOverlayClick}
          aria-hidden="true"
        />
      )}

      {/* Mobile Sidebar */}
      <aside 
        className={cn(
          "fixed inset-y-0 left-0 z-50 lg:hidden transition-transform duration-300",
          mobileMenuOpen ? "translate-x-0" : "-translate-x-full"
        )}
        aria-label="Mobile navigation"
        aria-hidden={!mobileMenuOpen}
      >
        <AppSidebar />
      </aside>

      {/* Main Content */}
      <div className="flex flex-1 flex-col">
        <Header 
          onMenuToggle={handleMenuToggle}
          isMobileMenuOpen={mobileMenuOpen}
        />
        <main id="main-content" className="flex-1 overflow-y-auto" role="main" tabIndex={-1}>
          <Outlet />
        </main>
        <Footer />
      </div>
      </SidebarProvider>
    </div>
  );
});
